<template>
    <div v-if="finance !== null">
        <md-card>
            <md-card-header>
                <md-card-header-text>
                    Variables de impacto del proyecto
                </md-card-header-text>
            </md-card-header>
            <md-card-content>
                <md-table class="md-dense">
                    <md-table-row>
                        <md-table-cell v-if="variant !== 'non-title'">Impacto económico</md-table-cell>
                        <md-table-cell md-numeric><span class="copy">{{getEconomicImpactValue|currency}}</span></md-table-cell>
                    </md-table-row>
                    <md-table-row>
                        <md-table-cell v-if="variant !== 'non-title'">Impacto ambiental</md-table-cell>
                        <md-table-cell md-numeric><span class="copy">{{getEnvironmentalImpactValue|currency}}</span></md-table-cell>
                    </md-table-row>
                </md-table>
            </md-card-content>
        </md-card>
    </div>
</template>

<script>
    export default {
        name: "ProjectImpact",
        props: {
            finance: {
                type: Object,
                required: true
            },
            compare: {
                type: Object,
                default: null
            },
            variant: {
                type: String,
                default: 'with-title'
            }
        },
        methods: {
            balance(total_cost, deposit) {
                return total_cost - deposit
            }
        },
        mounted() {
            $(".copy").click((e) => {
                this.$copyText(e.delegateTarget.innerText);
                this.$toasted.show("Texto copiado!", {
                    duration: 3000,
                    position: 'bottom-right'
                })
            })
        },
        computed: {
            getEconomicImpactValue(){
                return this.compare !== null ? this.compare.economic_impact : this.finance.economic_impact;
            },
            getEnvironmentalImpactValue(){
                return this.compare !== null ? this.compare.environmental_impact : this.finance.environmental_impact;
            }
        }
    }
</script>

<style scoped>

</style>
